'use strict';

if (typeof window !== 'undefined') {
  require('intersection-observer');
}

require('blob-polyfill');



// WEBPACK FOOTER //
// /www/client/config/polyfills.js